// extracted by mini-css-extract-plugin
export default {"progress_container":"chemical_progress_container__taglt","name":"chemical_name__8Hhr9","date":"chemical_date__zfnJ5"};